<template>
  <v-container>
    <v-dialog
        v-model="dialogDelete"
        width="500">
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Delete Variant
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You are about to delete the variant:
          <div class="primary-color">
            {{this.selectedVariant && this.selectedVariant.name }}
          </div>
          <br>
          It will become unavailable to affiliates.<br>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="copy-btn" @click="deleteVariant">
              YES, DELETE
            </v-btn>
          </v-col>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="6">
        <v-container>
          <v-row>
            <v-col cols="12">
              Variant
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      color="grey lighten-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="toggleInfoDialog('variant')"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>Click to view more about variants</span>
              </v-tooltip>
              <v-select
                  :items="variants"
                  item-text="name"
                  item-value="id"
                  label="Variants"
                  v-model="selectedVariantId"
                  @change="onVariantSelect"
                  solo
              ></v-select>

              <v-row no-gutters align="center">
                <v-col class="d-flex align-center" cols="auto">
                  <v-switch v-model="selectedVariant.isDefault" label="Make default"></v-switch>
                </v-col>
                <v-col class="d-flex align-center" cols="auto">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                              small
                              color="grey lighten-1"
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                      >
                      mdi-information
                      </v-icon>
                    </template>
                    <span>Making this variant the default one will replace any other default variant on this offer</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-dialog v-model="infoDialogs.variant" max-width="500px">
                <v-card>
                  <v-card-title class="d-flex justify-space-between align-center">
                    <span class="flex-grow-1 text-center">About Variant</span>
                    <v-btn icon @click="infoDialogs.variant = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    Some offers have variants landers (ex: a specific sport or event).
                    <br><br>
                    This dropdown lets you select a variant and see and/or upload its preview.
                    <br><br>
                    The campaign link generated will automatically include the necessary parameters to display the selected variant.
                  </v-card-text>
                </v-card>
              </v-dialog>


            </v-col>
          </v-row>
        </v-container>
        <v-row v-if="selectedVariant">
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <div class="image-upload-container">
                  <input
                      type="file"
                      @change="handleFileChange"
                      accept="image/*"
                      style="display: none"
                      ref="fileInput"
                  />
                  <div @click="openFileInput" class="upload-area">
                    <div v-if="assetData.imageUrl">
                      <img v-if="assetData.imageUrl" :src="assetData.imageUrl" alt="Preview" class="image-preview">
                    </div>
                    <div v-else>
                      <div class="upload-instructions">
                        Drag & drop files or
                        <span class="browse-link">Browse</span>
                      </div>
                      <div class="supported-format">
                        Supported format: JPEG, PNG, GIF, SFG, HEIC, WEBP
                      </div>
                    </div>
                  </div>

                  <div class="file-upload-details" v-if="isUploading">
                    <span>Uploading: {{ assetData.imageFileName }}</span>
                    <progress-bar :progress="uploadProgress"></progress-bar>
                  </div>
                  <div class="error-message" v-if="uploadError">
                    <span>{{ uploadErrorMessage }}</span>
                  </div>
                  <div  class="file-info">
                    <img v-if="assetData.imageUrl" :src="assetData.imageUrl" alt="Uploaded Image" class="uploaded-image-preview">
                    <div class="file-name">{{ assetData.imageFileName }}</div>
                    <div class="remove-file" @click="removeFile">&times;</div>
                  </div>
                  <div v-if="isUploading">Uploading...</div>
                </div>
                <v-btn
                    :disabled="!isUploadValid"
                    color="primary"
                    @click="uploadFile">Upload File
                </v-btn>
                <div class="mt-4">
                  Extra Parameter(s)
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                          small
                          color="grey lighten-1"
                          v-bind="attrs"
                          v-on="on"
                          @click="toggleInfoDialog('extraParams')"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>Add or remove additional parameters for the selected variant</span>
                  </v-tooltip>
                  <v-dialog v-model="infoDialogs.extraParams" max-width="500px">
                    <v-card>
                      <v-card-title class="d-flex justify-space-between align-center">
                        <span class="flex-grow-1 text-center">About Extra Parameters</span>
                        <v-btn icon @click="infoDialogs.extraParams = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        These parameters will be automatically added to campaign URLs linking to this offer. This is how you map a Variant to its Custom Assets.
                        <br><br>
                        Ex: if you see these two parameters:
                        <ul>
                          <li>Param 1:
                            <ul>
                              <li>Name: img</li>
                              <li>Value: 58</li>
                            </ul>
                          </li>
                          <li>Param 2:
                            <ul>
                              <li>Name: kw</li>
                              <li>Value: 59</li>
                            </ul>
                          </li>
                        </ul>
                        The campaign URL will contain the following at the end:
                        <br>https://...&img=58&kw=59
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-row v-for="(param, index) in selectedVariant.params" :key="index" class="my-2">
                    <v-col cols="5">
                      <v-text-field
                          v-model="param.name"
                          placeholder="Parameter Name"
                          persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                          v-model="param.value"
                          placeholder="Parameter Value"
                          persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-space-between align-center">
                      <v-btn color="primary" icon @click="removeParameter(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <br>
                  <v-btn color="primary" class="white--text" @click="addParameter()">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <br>
                <v-btn
                    color="error"
                    :disabled="!isCanBeDeleted()"
                    @click="openModal">Delete Variant
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <v-card>
          <v-card-title>
            <div class="d-flex align-center justify-space-between">
              Add a Variant
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      color="grey lighten-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="toggleInfoDialog('addVariant')"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>Click to view more about adding a variant</span>
              </v-tooltip>
            </div>
            <v-dialog v-model="infoDialogs.addVariant" max-width="500px">
              <v-card>
                <v-card-title class="d-flex justify-space-between align-center">
                  <span class="flex-grow-1 text-center">About Adding a Variant</span>
                  <v-btn icon @click="infoDialogs.addVariant = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  This is the name of the variant you want to create.
                  <br><br>
                  Once created, the variant can be selected in the Variant dropdown in this tab, so that preview and parameters can be set.
                </v-card-text>
              </v-card>
            </v-dialog>

          </v-card-title>
          <v-card-title>
            <v-text-field
                v-model="newVariantName"
                label="The name of new variant"
            ></v-text-field>
          </v-card-title>

          <v-card-actions>
            <v-btn color="primary" @click="createVariant">Create Variant</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-btn
              v-if="isVariantChanged()"
              fixed
              top
              right
              style="top: 50px"
              color="primary"
              class="upd-btn ma-0"
              @click="updateVariant"
          >
            Update
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import offerVariants from "@/api/offerVariants";
import ProgressBar from "@/components/pages/affiliates/customAssets/ProgressBar.vue";
import axios from "axios";

export default {
  name: 'VariantManager',
  components: {ProgressBar},
  props: {
    variants: Array,
    offerId: Number
  },
  data() {
    return {
      dialogDelete: false,
      originalVariant: null,
      selectedVariantId: null,
      selectedVariant: {},
      selectedFile: null,
      newVariantName: '',
      uploaded: false,
      dialog: false,
      assetData: {
        imageUrl: null,
        imageFileName: null
      },
      isUploading: false,
      uploadProgress: 0,
      uploadError: false,
      uploadErrorMessage: '',
      infoDialogs: {
        variant: false,
        addVariant: false,
        extraParams: false
      },
    };
  },
  mounted() {
    const defaultVariant = this.variants.find(v => v.isDefault);
    if (defaultVariant) {
      this.selectedVariantId = defaultVariant.id;
      this.selectedVariant = defaultVariant;
    }
  },
  methods: {
    toggleInfoDialog(dialog) {
      this.infoDialogs[dialog] = !this.infoDialogs[dialog];
    },
    isCanBeDeleted() {
      return this.variants.length > 1;
    },
    onVariantSelect() {
      this.selectedVariant = this.variants.find(v => v.id === this.selectedVariantId);

      if (this.selectedVariant.preSignedUrl) {
        this.assetData.imageUrl = this.selectedVariant.preSignedUrl;
      } else {
        this.assetData.imageUrl = null;
      }
      this.originalVariant = { ...this.selectedVariant };

    },
    async uploadFile() {
      if (!this.selectedVariant || !this.selectedVariant.id) return;
      const extension = this.selectedFile.name.split('.')[1];
      try {
        console.log('selectedVariant:', this.selectedVariant);
        const presignedURL = await offerVariants.offerVariantImageUploadUrl(
            this.selectedVariant.id,
            this.selectedVariant.name,
            extension,
            'PUT'
        );
        console.log('presignedURL successfully created :', presignedURL);
        await axios.put(presignedURL, this.selectedFile, {
          headers: {
            'Content-Type': this.selectedFile.type,
          },
        });

        const imageUrl = await offerVariants.offerVariantImageUploadUrl(
            this.selectedVariant.id,
            this.selectedVariant.name,
            extension,
            'GET'
        );
        console.log('File uploaded imageUrl:', imageUrl);
        this.assetData.imageUrl = imageUrl;
        this.uploaded = true;
        this.selectedVariant.preSignedUrl =imageUrl
        await this.updateVariant()
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];

      const file = event.target.files[0];
      if (file) {
        this.assetData.imageFileName = file.name;
        this.selectedVariant.imageName = file.name;
        this.uploadProgress = 0;
        this.uploadError = false;
        this.isUploading = true;

        const intervalId = setInterval(() => {
          if (this.uploadProgress >= 100) {
            clearInterval(intervalId);
            this.isUploading = false;
          } else {
            this.uploadProgress += 50;
          }
        }, 500);

      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
      this.selectedFile = this.$refs.fileInput
    },
    removeFile() {
      this.uploaded = false;
      this.assetData.imageFileName = '';
      this.assetData.imageUrl = '';
      this.selectedVariant.imageName = '';
    },
    async createVariant() {
      try {
        const response = await offerVariants.createOfferVariant(this.offerId, this.newVariantName);

        if (response.success) {
          const newVariantId = response.id;
          const newVariant = {
            id: newVariantId,
            name: this.newVariantName,
            params: [],
            preSignedUrl: null,
            isDefault: false,
          };

          this.variants.push(newVariant);

          this.selectedVariantId = newVariantId;
          this.selectedVariant = this.variants.find(v => v.id === newVariantId);

          this.assetData.imageUrl = this.selectedVariant?.preSignedUrl || null;

          this.newVariantName = '';

          await this.$dialog.notify.success(`Variant created successfully`, {
            position: 'top-right',
            timeout: 1000,
          });
        } else {
          await this.$dialog.notify.error(`Variant was not created`, {
            position: 'top-right',
            timeout: 2000,
          });
        }
      } catch (error) {
        console.error('Error creating variant:', error);
        await this.$dialog.notify.error(`An error occurred while creating variant`, {
          position: 'top-right',
          timeout: 2000,
        });
      }
    },

    closeModal() {
      this.dialogDelete = false;
    },
    async openModal() {
      this.dialogDelete = true;
    },
    async deleteVariant(){

      this.dialogDelete = false;
      const isDelVariant = await offerVariants.deleteOfferVariant(this.selectedVariant.id);
      if (isDelVariant) {
        this.variants = this.variants.filter(v => v.id !== this.selectedVariant.id);
        const getLastVariant = this.variants[0];
        if (getLastVariant) {
          this.selectedVariantId = getLastVariant.id;
          this.selectedVariant = getLastVariant;
        }
        await this.$dialog.notify.success(`variant was deleted successfully `, {
          position: 'top-right',
          timeout: 1000
        })
      } else {
        await this.$dialog.notify.error(`variant was not deleted  `, {
          position: 'top-right',
          timeout: 2000
        })
      }
    },
    async updateVariant() {
      const updateResponse = await offerVariants.updateOfferVariant(
          this.selectedVariant.id,
          this.selectedVariant.name ,
          '',
          this.selectedVariant.imageName,
          JSON.stringify(this.selectedVariant.params),
          this.selectedVariant.isDefault,
          this.offerId
      );

      if (updateResponse) {
        await this.$dialog.notify.success(`Updated successfully `, {
          position: 'top-right',
          timeout: 1000
        })
        await this.$store.dispatch('offer/saveOfferVariantsStore', this.offerId);
        this.variants = this.getOfferVariants
      }
      console.log('updateResponse:', updateResponse);
    },
    addParameter() {
      if (Array.isArray(this.selectedVariant.params)) {
        this.selectedVariant.params.push({ name: '', value: '' });
      } else {
        this.selectedVariant.params = [{ name: '', value: '' }];
      }
    },
    removeParameter(index) {
      if (Array.isArray(this.selectedVariant.params) && this.selectedVariant.params.length > 1) {
        this.selectedVariant.params.splice(index, 1);
      } else {
        this.selectedVariant.params = [];
      }
    },
    isVariantChanged() {
      const currentVariantSorted = JSON.stringify(this.selectedVariant);
      const originalVariantSorted = JSON.stringify(this.originalVariant);

      // if (JSON.stringify(this.originalVariant) === JSON.stringify(this.selectedVariant)){
      //   return false;
      // }

      return true
    },
  },
  watch: {
    selectedVariantId(newVal) {
      if (!newVal) {
        this.selectedVariant = null;
      } else {
        this.onVariantSelect();
      }
    },
    'selectedVariant.params': function (newValue) {
      if (typeof newValue === 'string') {
        this.selectedVariant.params = JSON.parse(newValue);
      }
    }
  },
  computed: {
    ...mapGetters('offer', ['getOfferVariants']),
    isUploadValid(){
      return this.assetData.imageFileName;
    },
  }
}
</script>

<style scoped>
.upload-area {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 20px;
}

.upload-area:hover {
  background-color: #f0f0f0;
}

.image-preview {
  max-width: 100%;
  max-height: 200px;
  margin-top: 10px;
}

.upload-instructions {
  font-size: 14px;
  color: #666;
}

.supported-format {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  background-color: #f4f4f4;
  border: 1px solid #e1e1e1;
  padding: 0.5rem;
}
.uploaded-image-preview {
  max-width: 50px;
  max-height: 50px;
  margin-right: 1rem;
}
.file-name {
  flex-grow: 1;
}
.remove-file {
  cursor: pointer;
  color: #ff0000;
  font-weight: bold;
}
ul {
  list-style-type: none;
  padding-left: 20px;
}

ul ul {
  padding-left: 20px;
}
.text-field-new-line {
  margin-top: 20px;
}
</style>

